import clubEventsService from '../services/clubEventsService';

export const fetchAllEvents = async (params) => {
  const result = await clubEventsService.getAllEvents(params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Etkinlikler alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const fetchEventById = async (id) => {
  const result = await clubEventsService.getEventById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Etkinlik alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const createEvent = async (payload) => {
  const result = await clubEventsService.createEvent(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Etkinlik oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const createEventWithGallery = async ({ dto, galleryImages }) => {
  const result = await clubEventsService.createEventWithGallery({ dto, galleryImages });
  if (!result?.success) {
    const error = new Error(result?.message || 'Etkinlik oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateEvent = async (payload) => {
  const result = await clubEventsService.updateEvent(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Etkinlik güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const deleteEvent = async (id) => {
  const result = await clubEventsService.deleteEvent(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Etkinlik silinemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const addParticipant = async ({ EventId, PersonId, Type }) => {
  const result = await clubEventsService.addParticipant({ EventId, PersonId, Type });
  if (!result?.success) {
    const error = new Error(result?.message || 'Katılımcı eklenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const addGuest = async (payload) => {
  const result = await clubEventsService.addGuest(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Misafir eklenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchGuestGroups = async (eventId) => {
  const result = await clubEventsService.getGuestGroups(eventId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Misafir grupları alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchGuestsByPersonId = async (eventId, personId, personType) => {
  const result = await clubEventsService.getGuestsByPersonId(eventId, personId, personType);
  if (!result?.success) {
    const error = new Error(result?.message || 'Misafirler alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateGuest = async (payload) => {
  const result = await clubEventsService.updateGuest(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Misafir güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const removeGuest = async (payload) => {
  const result = await clubEventsService.removeGuest(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Misafir silinemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateGuestAttendance = async (payload) => {
  const result = await clubEventsService.updateGuestAttendance(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Misafir katılım durumu güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchParticipants = async (eventId) => {
  const result = await clubEventsService.getParticipants(eventId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Katılımcılar alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchParticipantSummary = async (eventId) => {
  const result = await clubEventsService.getParticipantSummary(eventId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Katılımcı özeti alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const approveParticipant = async (payload) => {
  const result = await clubEventsService.approveParticipant(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Onay işlemi başarısız');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const removeParticipant = async (payload) => {
  const result = await clubEventsService.removeParticipant(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Katılımcı kaldırılamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchCalendarEvents = async (params) => {
  const result = await clubEventsService.getCalendarEvents(params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Etkinlikler alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateParticipantAttendance = async (payload) => {
  const result = await clubEventsService.updateParticipantAttendance(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Katılım durumu güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const searchClubEvents = async (params) => {
  const result = await clubEventsService.searchEvents(params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Etkinlik araması başarısız');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const fetchParticipantStatsByMemberId = async (memberId, type) => {
  const result = await clubEventsService.getParticipantStatsByMemberId(memberId, type);
  if (!result?.success) {
    const error = new Error(result?.message || 'Katılımcı istatistikleri alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchTopParticipantsByAttendanceRate = async (topCount = 20) => {
  const result = await clubEventsService.getTopParticipantsByAttendanceRate(topCount);
  if (!result?.success) {
    const error = new Error(result?.message || 'En yüksek katılım oranına sahip katılımcılar alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchAllParticipantStats = async (params) => {
  const result = await clubEventsService.getAllParticipantStats(params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Katılımcı istatistikleri alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const fetchParticipantStatsById = async (id) => {
  const result = await clubEventsService.getParticipantStatsById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Katılımcı istatistiği alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const recalculateParticipantStats = async (memberId, type) => {
  const result = await clubEventsService.recalculateParticipantStats(memberId, type);
  if (!result?.success) {
    const error = new Error(result?.message || 'İstatistikler yeniden hesaplanamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const recalculateAllParticipantStats = async () => {
  const result = await clubEventsService.recalculateAllParticipantStats();
  if (!result?.success) {
    const error = new Error(result?.message || 'Tüm istatistikler yeniden hesaplanamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchEventAttendanceReport = async (eventId) => {
  const result = await clubEventsService.getEventAttendanceReport(eventId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Katılım raporu alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const downloadEventAttendanceReportExcel = async (eventId) => {
  try {
    return await clubEventsService.downloadEventAttendanceReportExcel(eventId);
  } catch (error) {
    const blob = error?.response?.data;
    if (blob instanceof Blob) {
      const text = await blob.text();
      try {
        const parsed = JSON.parse(text);
        throw new Error(parsed?.message || 'Katılım listesi indirilemedi');
      } catch (parseError) {
        if (parseError instanceof SyntaxError) {
          throw new Error('Katılım listesi indirilemedi');
        }
        throw parseError;
      }
    }
    throw error;
  }
};

export default {
  fetchAllEvents,
  fetchEventById,
  createEvent,
  createEventWithGallery,
  updateEvent,
  deleteEvent,
  addParticipant,
  addGuest,
  fetchGuestGroups,
  fetchGuestsByPersonId,
  updateGuest,
  removeGuest,
  updateGuestAttendance,
  fetchParticipants,
  fetchParticipantSummary,
  approveParticipant,
  removeParticipant,
  updateParticipantAttendance,
  fetchCalendarEvents,
  searchClubEvents,
  fetchParticipantStatsByMemberId,
  fetchTopParticipantsByAttendanceRate,
  fetchAllParticipantStats,
  fetchParticipantStatsById,
  recalculateParticipantStats,
  recalculateAllParticipantStats,
  fetchEventAttendanceReport,
  downloadEventAttendanceReportExcel,
};


